import { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export type ApprenticeWizardDto = {
  companyName?: string;
  contactName?: string;
  email?: string;
  phone?: string;
  taxNumber?: string;
  status?: number;
};

export type ApprenticeWizardPaginatedResultDto = {
  items?: ApprenticeWizardDto[];
  totalCount?: number;
};

function parseMaybeJson(
  value: ApprenticeWizardPaginatedResultDto | string,
): ApprenticeWizardPaginatedResultDto {
  if (typeof value !== "string") return value;

  try {
    return JSON.parse(value) as ApprenticeWizardPaginatedResultDto;
  } catch {
    throw new Error("Invalid response: expected JSON payload.");
  }
}

export class AdminApprenticeWizardsService {
  public static getAdminApprenticeWizards(
    sorting?: string,
    skip?: number,
    pageSize?: number,
    maxPageSize?: number,
  ): CancelablePromise<ApprenticeWizardPaginatedResultDto> {
    const raw = __request<ApprenticeWizardPaginatedResultDto | string>(
      OpenAPI,
      {
        method: "GET",
        url: "/admin/apprenticeWizards",
        query: {
          Sorting: sorting,
          Skip: skip,
          PageSize: pageSize,
          MaxPageSize: maxPageSize,
        },
      },
    );

    return new CancelablePromise((resolve, reject, onCancel) => {
      onCancel(() => raw.cancel());
      raw
        .then((value) => {
          try {
            resolve(parseMaybeJson(value));
          } catch (e) {
            reject(e);
          }
        })
        .catch(reject);
    });
  }
}
